let resourceInterception = (config, defn, type = 'cs') => {
    console.log(config, defn, type);
    let json = JSON.parse(config);
    if (defn === 'AS2') {
        if (type === 'cs') {
            return '127.0.0.1:' + json.port;
        } else {
            return json.host + ':' + json.port;
        }
    } else if (defn === 'AS3') {
        if (type === 'cs') {
            return json.serverout;
        } else {
            return json.clientmdn;
        }
    } else if (defn === 'DIR' || defn === 'FTP' || defn === 'FTPS' || defn === 'SFTP') {
        if (type === 'cs') {
            return json.recedir;
        } else {
            return json.senddir;
        }
    } else if (defn === 'RCTMQ' || defn === 'RMQ' || defn === 'WMQ') {
        if (type === 'cs') {
            return json.recequeue;
        } else {
            return json.sendqueue;
        }
    } else if (defn === 'SOAP') {
        if (type === 'cs') {
            return '127.0.0.1:' + json.port + json.reqpath + '/dxpcli';
        } else {
            return json.method;
        }
    }
    return config;
}

export default {resourceInterception}